import { render, staticRenderFns } from "./AreaPicker.vue?vue&type=template&id=55d7563e&scoped=true"
import script from "./AreaPicker.vue?vue&type=script&lang=js"
export * from "./AreaPicker.vue?vue&type=script&lang=js"
import style0 from "./AreaPicker.vue?vue&type=style&index=0&id=55d7563e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d7563e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55d7563e')) {
      api.createRecord('55d7563e', component.options)
    } else {
      api.reload('55d7563e', component.options)
    }
    module.hot.accept("./AreaPicker.vue?vue&type=template&id=55d7563e&scoped=true", function () {
      api.rerender('55d7563e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/officeApproval/common/form/components/AreaPicker.vue"
export default component.exports